import { Box, Typography, Link } from "@mui/material";
import { useBranding } from "../hooks/brandingProvider";

const Footer = () => {
  const { footer_text: footerText } = useBranding();

  return (
    <Box
      component="footer"
      sx={{
        textAlign: "center",
        p: 1,
        backgroundColor: "#f8f9fa",
        mt: 4,
      }}
    >
      {footerText ? (
        <Typography variant="body2" color="textSecondary">{footerText}</Typography>
      ) : (
        <Typography variant="body2" color="textSecondary">
          &copy; {new Date().getFullYear()} BotBridge by{" "}
          <Link
            href="https://www.bizcollab360.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Bizcollab360 Tech Pvt Ltd
          </Link>
          . All Rights Reserved.
        </Typography>
      )}
    </Box>
  );
};

export default Footer;
